const TabsButtons = ({ tabs = [], active, setActive }) => {
  return (
    <div className='block'>
      <div className='border-b border-gray-200'>
        <div className='-mb-px flex gap-6' aria-label='Tabs'>
          {tabs?.map((tab) => (
            <button
              key={tab.value}
              onClick={() => setActive(tab.value)}
              className={`hover:border-primary hover:text-primary shrink-0 cursor-pointer border-b-2 border-transparent px-1 pb-4 font-medium max-md:pb-3 max-md:text-sm max-sm:pb-2 max-sm:text-xs ${active === tab.value ? 'text-primary !border-primary' : ''}`}
            >
              {tab.labeL}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabsButtons;
